const parseOrderBy = ({ orderBy, orderDirection }) => {
  if (!orderBy) {
    return undefined;
  }
  return `${orderBy.field}:${orderDirection}`;
};

export default parseOrderBy;
